import React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1270px" viewBox="0 0 414 1126" {...props}>
      <title>{"headercouper"}</title>
      <defs>
        <path id="prefix__a" d="M0 0h1256v1128H0z" />
        <path id="prefix__c" d="M.135.137h1256.128v758.129H.135z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-491)">
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            d="M864.759-138.053c-121.302-67.168-268.552-67.173-389.85-.013l-838.095 464.069c-113.89 63.063-92.676 347.317 21.218 410.382L474.95 1080.23c121.301 67.173 268.552 67.178 389.849.013l838.095-464.069c113.89-63.058 113.885-227.033-.01-290.104L864.76-138.053z"
            fill="#E9F9F8"
            mask="url(#prefix__b)"
            transform="rotate(10 674.788 471.09)"
          />
        </g>
        <g transform="translate(-491)">
          <mask id="prefix__d" fill="#fff">
            <use xlinkHref="#prefix__c" />
          </mask>
          <path
            d="M1400.474 279.165l-320.153-177.12c-46.336-25.632-102.598-25.608-148.955.063l-320.3 177.386c-43.527 24.105-43.553 86.732-.047 110.799l320.153 177.119c46.336 25.634 102.598 25.61 148.955-.062l320.3-177.386c43.527-24.103 43.553-86.73.047-110.8"
            fill="#FCBD39"
            mask="url(#prefix__d)"
            transform="rotate(27 1005.747 334.73)"
          />
          <path
            d="M1416.87-71.464L752.9-438.618c-96.096-53.134-212.77-53.102-308.894.085l-664.17 367.516c-90.256 49.943-90.292 179.73-.064 229.619l663.97 367.154c96.096 53.139 212.77 53.107 308.894-.085l664.171-367.516c90.255-49.938 90.29-179.726.063-229.619"
            fill="#1FDDB3"
            mask="url(#prefix__d)"
            transform="rotate(16 598.321 43.57)"
          />
          <path
            d="M319.817-56.094c-72.02-39.889-159.427-39.929-231.412-.105l-482.427 334.986c-67.589 37.394-67.544 134.7.078 172.152L103.68 726.567c72.02 39.892 159.427 39.932 231.412.106l497.372-275.176c67.59-37.39 67.545-134.696-.078-172.152L319.817-56.094z"
            fill="#08AEEA"
            style={{
              mixBlendMode: "multiply"
            }}
            mask="url(#prefix__d)"
            transform="rotate(-31 219.221 335.238)"
          />
        </g>
        <path
          d="M891.677 464.944l-204.848-303.5A153.723 153.723 0 00554.08 93.799L188.16 106.452c-49.725 1.72-78.18 57.57-50.343 98.812l204.849 303.501a153.712 153.712 0 00132.747 67.644l365.922-12.652c49.725-1.718 78.18-57.57 50.343-98.813"
          fill="#FCBD39"
        />
        <path
          d="M925.868 158.793L388.821-377.754C311.093-455.405 198.93-487.57 91.87-462.911l-739.744 170.4c-100.524 23.156-136.333 148.046-63.351 220.954l537.047 536.547c77.727 77.655 189.889 109.82 296.951 85.157l739.744-170.4c100.523-23.152 136.332-148.042 63.351-220.954"
          fill="#08AEEA"
        />
        <path
          d="M-387.102-52.068c-82.278 2.905-157.22 47.94-198.413 119.23l-240.99 536.208c-38.676 66.939 11.478 150.416 88.732 147.688L-169.268 731c82.28-2.902 157.223-47.937 198.413-119.23l284.606-492.589c38.677-66.936-11.477-150.413-88.732-147.688L-387.1-52.068z"
          fill="#1FDDB3"
          style={{
            mixBlendMode: "multiply"
          }}
        />
      </g>
    </svg>
  )
}

export const HeaderCouperMobile = React.memo(SvgComponent)

HeaderCouperMobile.displayName = "HeaderCouperMobile"
